import { _, helpers, ts } from '_core';

import { DraftParams } from './types';

// prepareLinearData
export const transform = (
  data: ts.types.widgets.TableData,
  isBasket: boolean,
  hasBenchmark: boolean,
  timeSeries: ts.types.timeSeries.TimeSeries[] = [],
  showTargetWeight?: boolean
) => {
  const tsHandles = timeSeries.map((ts) => ts.handle);
  const newData = data.map((item) => {
    const newItem = {
      date: item.date,
      [isBasket ? 'Basket Weights' : 'Portfolio Returns']: item.portfolio_returns || item.return,
    } as ts.types.widgets.TableData[number];

    const shouldShowBenchmarkData = isBasket ? showTargetWeight : true;
    if (hasBenchmark && shouldShowBenchmarkData) {
      newItem[isBasket ? 'Target Weights' : 'Benchmark Returns'] = item.benchmark_returns;
      newItem['Active'] = item.active_returns;
    }

    Object.keys(item).forEach((key) => {
      if (tsHandles.includes(key)) {
        const foundTs = timeSeries.find((ts) => ts.handle == key);
        const newKey = helpers.resourcesUtils.getResourceLabel(foundTs);
        newItem[newKey] = item[key];
      }
    });
    return newItem;
  });

  return newData;
};

export const validate = (params: DraftParams) => {
  if (_.isEmpty(params.analysis_time_series_ids)) return ['You need to add at least one time series.'];
  if (params.analysis_time_series_ids.length > 3) return ['You can only add a max of three time series.'];
  return [];
};
